import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { moment } from 'localization'

import ExpandableWidget from 'components/ExpandableWidget/ExpandableWidget'
import BarChart from 'components/charts/BarChart/BarChart'
import { useFetch } from '../../store'

import styles from './ContextualController.module.sass'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import Widget from '@jimmyboys/liita-ui/dist/components/Widget'
import Collection from '@jimmyboys/liita-ui/dist/components/Collection'
import queryString from 'query-string'

const SegmentRow = (props) => {
	const { data, ...attributes } = props
	const location = useLocation()
	const queryParams = queryString.parse(location.search)
	const search = queryString.stringify({
		...queryParams,
		segment: data?.segment?.abbreviation,
	})
	return (
		<div {...attributes} className={styles['row']}>
			<h5>{data?.segment?.name}</h5>
			<Link
				to={{
					search,
				}}
			>
				<small>{data?.count || 0}</small>
			</Link>
		</div>
	)
}

const ContextualClinicalProcessesController = () => {
	const { i18n } = useGlobal()
	const uri = `/clinical_processes/stats`
	const { contents } = useFetch(uri)
	const processesPerDay = (
		contents && contents.dayResults ? contents.dayResults : []
	).map(({ date, total }) => {
		return {
			date: moment(new Date(date)).format('DD'),
			total,
		}
	})
	const processesPerSegment =
		contents && contents.processesPerSegment
			? contents.processesPerSegment
			: []

	return (
		<>
			<Widget
				className={styles['welcome-widget']}
				paddings={['small', '', '']}
			>
				<h2 className={styles['welcome-title']}>{i18n`Stats`}</h2>
				<small>{i18n`Last seven days summary and more`}</small>
			</Widget>
			<ExpandableWidget
				className={styles['aside-widget']}
				titleAppearance='aside-widget'
				heading='h5'
				title={i18n`Last 7 days`}
				expanded
				borderRadius
				margins={['small', '', '']}
				paddings={['', 'xsmall', 'xsmall']}
			>
				<BarChart
					data={processesPerDay}
					category='date'
					value='total'
				/>
			</ExpandableWidget>
			<ExpandableWidget
				className={styles['aside-widget']}
				titleAppearance='aside-widget'
				heading='h5'
				title={i18n`By Type`}
				expanded
				borderRadius
				margins={['small', '', '']}
				paddings={['', 'xsmall', 'xsmall']}
			>
				<Widget className={styles['aside-widget-content']}>
					<div className={styles['list-header']}>
						<h5>&nbsp;</h5>
						<small>{i18n`Processes`}</small>
					</div>
					<Collection
						itemsHeight={28}
						card={SegmentRow}
						items={processesPerSegment}
					/>
				</Widget>
			</ExpandableWidget>
		</>
	)
}

export default ContextualClinicalProcessesController
